import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Select,
  MenuItem,
  Button,
  TextField,
  Grid,
  Box,
  FormControl,
  InputLabel,
  Typography,
  FormHelperText,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const AddModel = ({
  handleClose,
  openDialog,
  isEditMode,
  brandList,
  onAddEditModelSubmit,
  register,
  handleSubmit,
  errors,
  formData,
  onFamilyClick,
  brickList,
  onBrandSelectedClick,
  categoryListOnBrandId,
  setBrickName,
  isUpdateButton,
  setIsUpdateButton,
  onCategoryClick,
  productFamilyList,
  disableCategoryDropdown,
  disableFamilyDropdown,
  disableBrickDropdown,
  setValue
}) => {
  const { content } = brickList;
  const [productCategoryId, setProductCategoryId] = useState(
    formData.productCategoryId ?? null
  );
  const [productCatFamilyMappingId, setProductCatFamilyMappingId] = useState(
    formData.productCatFamilyMappingId ?? null
  );
  const [_brickId, setBrickId] = useState(formData.brickId ?? null);
  useEffect(()=>{
    setProductCategoryId(null);
    setProductCatFamilyMappingId(null);
    setBrickId(null);

  },[openDialog,isEditMode])
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"sm"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>{!isEditMode ? "Add Model" : "Edit Model"}</b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 2 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={1}
                    justifyContent="left"
                    alignItems="center">
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Brand-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Brand
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Brand"
                            name="brandId"
                            fullWidth
                            defaultValue={formData.brandId}
                            size="small"
                            autoComplete="off"
                            {...register("brandId", { required: true })}
                            error={Boolean(errors?.brandId)}
                            helperText={errors?.brandId?.message}
                            onChange={() => {
                              setProductCategoryId(null);
                              setProductCatFamilyMappingId(null);
                              setBrickId(null);
                              setIsUpdateButton(false);
                            }}>
                            {brandList &&
                              brandList.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.brandId}
                                    sx={{ width: "100%" }}
                                    value={d.brandId}
                                    size="small"
                                    onClick={() => {
                                      onBrandSelectedClick(d.brandId, d.name);
                                      //resetDefalutVal();
                                    }}>
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.brandId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Select-Category-label"
                            sx={{ marginTop: "-6px" }}>
                            Product Category
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Product Category"
                            name="productCategoryId"
                            fullWidth
                            size="small"
                            // defaultValue={formData.productCategoryId}
                            value={
                              productCategoryId ??
                              formData?.productCategoryId ??
                              null
                            }
                            autoComplete="off"
                            {...register("productCategoryId", {
                              required: true,
                            })}
                            disabled={disableCategoryDropdown}
                            error={Boolean(errors?.productCategoryId)}
                            helperText={errors?.productCategoryId?.message}
                            // onClick={()=>setCategoryListOnBrandId(_categoryListOnBrandId)}
                            onChange={(e) => {
                              setProductCategoryId(e.target.value);
                              setProductCatFamilyMappingId(null);
                              setBrickId(null);
                              setIsUpdateButton(false);
                            }}>
                            {categoryListOnBrandId &&
                            categoryListOnBrandId.length > 0 ? (
                              categoryListOnBrandId?.map((d) => {
                                return (
                                  <MenuItem
                                    key={d?.productCategoryId}
                                    sx={{ width: "100%" }}
                                    value={d?.productCategoryId}
                                    size="small"
                                    onClick={() =>
                                      onCategoryClick(
                                        d?.productCategoryId,
                                        d?.name
                                      )
                                    }>
                                    {d?.name}
                                  </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem>Record not found</MenuItem>
                            )}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.productCategoryId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Segment-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Product Family
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            name="productCatFamilyMappingId"
                            label="Product Family"
                            fullWidth
                            //defaultValue={formData.productCatFamilyMappingId}
                            value={
                              productCatFamilyMappingId ??
                              formData?.productCatFamilyMappingId ??
                              null
                            }
                            size="small"
                            autoComplete="off"
                            {...register("productCatFamilyMappingId", {
                              required: true,
                            })}
                            disabled={disableFamilyDropdown}
                            error={Boolean(errors?.productCatFamilyMappingId)}
                            helperText={
                              errors?.productCatFamilyMappingId?.message
                            }
                            onChange={(e) => {
                              setProductCatFamilyMappingId(e.target.value);
                              setBrickId(null);
                              setIsUpdateButton(false);
                            }}>
                            {productFamilyList?.content &&
                              productFamilyList?.content.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.productCatFamilyMappingId}
                                    sx={{ width: "100%" }}
                                    value={d.productCatFamilyMappingId}
                                    size="small"
                                    onClick={() =>
                                      onFamilyClick(
                                        d.productCatFamilyMappingId,
                                        d.productFamilyName
                                      )
                                    }>
                                    {d.productFamilyName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors &&
                              errors?.productCatFamilyMappingId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="Brick-select-label"
                            sx={{ marginTop: "-6px" }}>
                            Brick
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            name="brickId"
                            label="Brick"
                            fullWidth
                            // defaultValue={formData.brickId}
                            value={_brickId ?? formData?.brickId ?? null}
                            size="small"
                            disabled={disableBrickDropdown}
                            autoComplete="off"
                            {...register("brickId", { required: true })}
                            error={Boolean(errors?.brickId)}
                            helperText={errors?.brickId?.message}
                            onChange={(e) => {
                              setBrickId(e.target.value);
                              setIsUpdateButton(false);
                            }}>
                            {content &&
                              content.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.brickId}
                                    sx={{ width: "100%" }}
                                    value={d.brickId}
                                    size="small"
                                    onClick={() => setBrickName(d.brickName)}>
                                    {d.brickName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.brickId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <TextField
                          className="stepperFormInput"
                          label="Article"
                          name="modelName"
                          placeholder="Enter article name"
                          fullWidth
                          size="small"
                          required
                          autoComplete="off"
                          {...register("modelName", { required: true })}
                          error={errors?.modelName}
                          helperText={errors?.modelName?.message}
                          onChange={() => setIsUpdateButton(false)}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <TextField
                          className="stepperFormInput"
                          label="Article Short Name"
                          name="shortName"
                          placeholder="Enter short name"
                          fullWidth
                          required
                          size="small"
                          autoComplete="off"
                          {...register("shortName", { required: true })}
                          error={Boolean(errors?.shortName)}
                          helperText={errors?.shortName?.message}
                          onChange={() => setIsUpdateButton(false)}
                          onBlur={(e) => {
                            let str = e.target.value;
                            setValue("shortName", str.trim());
                           
                          }}
                        />
                      </Grid>
                      <Grid container sx={{ mt: 2 }}>
                        <Grid item xs={6} sx={{ pr: 1 }}>
                          <FormControl fullWidth>
                            <InputLabel
                              id="Segment-select-label"
                              sx={{ marginTop: "-6px" }}>
                              Is Active?
                            </InputLabel>
                            <Select
                              className="stepperFormInput"
                              label="Is Active?"
                              name="active"
                              fullWidth
                              required
                              defaultValue={
                                Object.prototype.hasOwnProperty.call(
                                  formData,
                                  "active"
                                )
                                  ? Boolean(formData.active)
                                  : true
                              }
                              size="small"
                              autoComplete="off"
                              {...register("active")}
                              // error={Boolean(errors?.isActive)}
                              // helperText={errors?.isActive?.message}
                              onChange={() => setIsUpdateButton(false)}>
                              <MenuItem
                                native
                                sx={{ width: "100%" }}
                                value={true}
                                size="small">
                                Yes
                              </MenuItem>
                              <MenuItem
                                native
                                sx={{ width: "100%" }}
                                value={false}
                                size="small">
                                No
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          <TextField
                            className="stepperFormInput"
                            label="Article Description"
                            name="modelDesc"
                            placeholder="Enter model description"
                            fullWidth
                            required
                            size="small"
                            autoComplete="off"
                            {...register("modelDesc", {
                              required: true,
                            })}
                            error={Boolean(errors?.modelDesc)}
                            helperText={errors?.modelDesc?.message}
                            onChange={() => setIsUpdateButton(false)}
                            onBlur={(e) => {
                              let str = e.target.value;
                              setValue("modelDesc", str.trim());
                             
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "8px",
                              color: "#909090",
                              textAlign: "right",
                            }}>
                            max 2000 characters
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 1, pl: 55 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddEditModelSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}>
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained">
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddModel;
